import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {StoreSelectorsService} from "../../../../services";
import {IAppSettingsWrap, IBaseBlockComponent, IPlayerProps} from "../../../../interfaces";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {ToastrService} from "ngx-toastr";
import {DEFAULT_DEV_SERVER, isHostDev, isHostLocal, REMOTE_PAD_URL, REMOTE_TOUCH_URL} from "../../../../common";
import {Lib} from "../../../../../libs/Lib";
import {SelectionModel} from "@angular/cdk/collections";
import * as _ from "lodash";
import {SceneMimeTypes} from "../mime-constants";

@Component({
    selector: 'app-scene-block-qr',
    templateUrl: './block-qr.component.html',
    styleUrls: ['./block-qr.component.scss']
})

export class BlockQrComponent extends BlockBaseComponent implements IBaseBlockComponent {
    textSources = [
        {
            optionsLabel: 'plain text',
            optionValue: 'static',
            optionType: 'text'
        },
        // {
        //     optionsLabel: 'play this scene',
        //     optionValue: 'scene',
        //     optionType: 'text'
        // },
        {
            optionsLabel: 'url content',
            optionValue: 'dynamic',
            optionType: 'text'
        },
        {
            optionsLabel: 'remote pad',
            optionValue: 'remotePad',
            optionType: 'text'
        },
        {
            optionsLabel: 'remote touch',
            optionValue: 'remote',
            optionType: 'text'
        }
    ];

    showCode = false;
    coreAppData: IAppSettingsWrap;
    selectionModel: SelectionModel<number>;
    scenesSimple: Array<{ name, sceneId }>;
    assignedScene;

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog, private toastr: ToastrService) {
        super(storeSelector, dialog);
        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => this.coreAppData = i_coreData)
        );
        this.cod(
            this.storeSelector.getScenes(true)
                .subscribe((i_scenes: IPlayerProps[]) => {
                    const scenes = _.orderBy(i_scenes, (v: IPlayerProps) => {
                        return v.Player.$.label.toLocaleLowerCase();
                    }, ['asc']);
                    this.scenesSimple = [];
                    scenes.forEach((scene) => {
                        if (scene.Player.$.mimeType == SceneMimeTypes.Player || scene.Player.$.mimeType.length === 0) {
                            this.scenesSimple.push({name: scene.Player.$.label, sceneId: scene.Player.$.id});
                        }
                    });
                })
        );
    }

    override submit(formValues) {
        switch (formValues.textSource) {
            case 'scene': {
                delete formValues.url;
                delete formValues.limitedUser;
                delete formValues.limitedPassword;
                formValues.textSource = 'static';
                formValues._ = this.createPreviewUrl(this.assignedScene.sceneId);
                this.setFormValue('_', formValues._);
                break;
            }
            case 'static': {
                delete formValues.url;
                delete formValues.limitedUser;
                delete formValues.limitedPassword;
                break;
            }
            case 'dynamic': {
                delete formValues._;
                delete formValues.limitedUser;
                delete formValues.limitedPassword;
                break;
            }
            case 'remotePad': {
                delete formValues._;
                formValues.url = REMOTE_PAD_URL;
                break;
            }
            case 'remote': {
                delete formValues._;
                formValues.url = REMOTE_TOUCH_URL;
                break;
            }
        }
        super.submit(formValues);
    }

    override initApplyStoreToDynamic(applyStoreToDynamic: boolean = false) {
        super.initApplyStoreToDynamic(applyStoreToDynamic);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        this.showCode = false;
        switch (this.sceneItem.Data[0].Text[0].$.textSource) {
            case 'static': {
                this.setUiConfigHide('_', false);
                this.setUiConfigHide('url', true);
                this.setUiConfigHide('limitedUser', true);
                this.setUiConfigHide('limitedPassword', true);
                break;
            }
            case 'dynamic': {
                this.setUiConfigHide('_', true);
                this.setUiConfigHide('url', false);
                this.setUiConfigHide('limitedUser', true);
                this.setUiConfigHide('limitedPassword', true);
                this.showCode = true;
                break;
            }
            case 'remotePad': {
                this.setUiConfigHide('_', true);
                this.setUiConfigHide('url', false);
                this.setUiConfigHide('limitedUser', false);
                this.setUiConfigHide('limitedPassword', false);
                this.setFormValue('url', REMOTE_PAD_URL);
                break;
            }
            case 'remote': {
                this.setUiConfigHide('_', true);
                this.setUiConfigHide('url', false);
                this.setUiConfigHide('limitedUser', false);
                this.setUiConfigHide('limitedPassword', false);
                this.setFormValue('url', REMOTE_TOUCH_URL);
                break;
            }
        }
        super.componentStoreUpdates();
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "select",
                label: this.translocoService.translate('general.plainText2', {}, this.translocoService.getActiveLang()),
                name: "textSource",
                value: "static",
                options: this.textSources,
                restrictChar: "basic3",
                storePath: 'Data[0].Text[0].$.textSource'
            },
            {
                type: "input",
                value: "",
                label: this.translocoService.translate('general.url', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "url",
                restrictChar: "basic3",
                ignoreMissingValue: true,
                storePath: 'Data[0].Text[0].$.url'
            },
            {
                type: "input",
                value: "",
                label: this.translocoService.translate('general.limitedUser', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "limitedUser",
                restrictChar: "basic3",
                ignoreMissingValue: true,
                storePath: 'Data[0].Text[0].$.limitedUser'
            },
            {
                type: "input",
                value: "",
                label: this.translocoService.translate('general.limitedPassword', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                restrictChar: "basic3",
                name: "limitedPassword",
                ignoreMissingValue: true,
                storePath: 'Data[0].Text[0].$.limitedPassword'
            },
            {
                type: "input",
                value: "",
                label: this.translocoService.translate('general.content', {}, this.translocoService.getActiveLang()),
                inputType: "textarea",
                restrictChar: "basic3",
                name: "_",
                ignoreMissingValue: true,
                storePath: 'Data[0].Text[0]._'
            }
            // ,{
            //     type: "checkbox",
            //     value: '1',
            //     label: this.translocoService.translate('general.gpu', {}, this.translocoService.getActiveLang()),
            //     name: "gpu",
            //     storePath: '$.gpu'
            // }
        ];
    }

    onCopy() {
        this.toastr.info(this.translocoService.translate('toast.copiedToClip', {}, this.translocoService.getActiveLang()));
        // const copyText: any = document.getElementById("snippet");
        // copyText.select();
        // copyText.setSelectionRange(0, 99999);
        // copyTextClipboard(copyText.value);
    }

    onSceneChange() {
        this.submit({
            textSource: 'scene',
            _: this.createPreviewUrl(this.assignedScene.sceneId)

        });
        this.setFormValue('_', this.createPreviewUrl(this.assignedScene.sceneId));
        this.setFormValue('textSource', 'static');
    }

    createPreviewUrl(i_sceneId): string {
        const devFlag = '';
        let server = '';
        if (this.isFullFeatures || Lib.DevMode() || isHostDev() || isHostLocal()) {
            server = DEFAULT_DEV_SERVER;
            if (this.isFullFeatures) {
                // devFlag = '&dev=1';
            }
        } else {
            server = this.coreAppData[1].masterServer;
        }
        return `https://${server}/signplayer?domain=${this.coreAppData[1].masterServer}&businessId=${this.coreAppData[0].businessId}&sceneId=${i_sceneId}&token=${this.coreAppData[0].webToken}${devFlag}`;
    }
}


// const url = this.createPreviewUrl(e.value.sceneId);
//     delete formValues.url;
//     delete formValues.limitedUser;
//     delete formValues.limitedPassword;
// formValues.textSource = 'static';
// formValues._ = this.createPreviewUrl();
// this.setFormValue('_', url);
// break;
